import { api } from ":mods";
import { CONST, model } from "..";
import { AResource } from "../../model";
export async function listPost(stage: number | string, data: model.PostResource) {
  return api
    .postAuth(CONST.ENDPOINTS.admin.list_resources(stage), data, {
      headers: {
        // "Content-Type": "application/json",
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      return res.data.data.resources as AResource;
    });
}
